import React, { useEffect, useState } from "react";
import QueryString from "qs";
import { useSelector } from "react-redux";
import apiService from "@/common/services/apiService";

import ReactPaginate from "react-paginate";
import Link from "next/link";
import { decodeHTMLEntities, toWebp, getArticleUrl } from "@/utils/common";

import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import Image from "next/image";
import { RootState } from "@/store/store";
dayjs.extend(advancedFormat);

const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL;

const CategoryStories: React.FC<{ block: any }> = ({ block }) => {
  const search = useSelector((state: RootState) => state.loader.search); // const dispatch = useDispatch();
  const [pageLoader, setPageLoader] = useState(true); // const inputElement = useRef(null);
  const [allStories, setStories] = useState<any>([]);
  const [pagination, setPagination] = useState<any>([]);
  const [filter, setFilter] = useState<any>({ slug: { $ne: "blog" } }); // const [page, setPage] = useState(null);
  const pageSize = 4;
  // const handleSearch = (event) => {
  //   event.preventDefault();
  //   dispatch({
  //     type: "CALL_SEARCH",
  //     payload: inputElement.current.value,
  //   });
  // };

  const fetchStories = async (page = 1) => {
    const filterObj = filter;
    const title = search;
    if (title !== null && title !== "") {
      setFilter({ ...filter, ["title"]: { $containsi: title } });
      filterObj.title = { $containsi: title };
    } else {
      setFilter(filterObj);
      delete filterObj.title;
    }

    filterObj.categories = { slug: { $containsi: block.slug } };

    const query = QueryString.stringify(
      {
        filters: filterObj,
        populate: "deep, 10",
        pagination: {
          page: page || 1,
          pageSize: pageSize,
        },
      },
      {
        encodeValuesOnly: false,
      }
    );

    const lst: any = await apiService.getapi1(
      "articles?" + decodeURIComponent(query)
    );
    setPageLoader(false);
    setStories(lst.data.data);
    setPagination(lst.data.meta.pagination);
  };

  const handlePageClick = (event: any) => {
    setPageLoader(true);
    // setPage(event.selected + 1);
    fetchStories(event.selected + 1);
  };

  useEffect(() => {
    setPageLoader(true);
    fetchStories(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  return (
    <div className="blog-page-section">
      <section className="blog-allstories-section">
        <div className="blog-allstories-inner">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="blog-allstories-heading mt-5">
                  <h2 className="h4">{block.name}</h2>
                </div>
              </div>
            </div>
            <div className="row">
              {pageLoader ? (
                <div
                  className="col-12 text-center d-flex align-items-center justify-content-center"
                  style={{ minHeight: (pageSize / 2) * 260 + "px" }}
                >
                  <div className="lds-ellipsis">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                </div>
              ) : allStories.length > 0 ? (
                allStories.map((ele: any, i: number) => {
                  const authorName = ele?.attributes.authors.data
                    ?.map((a: any) => a.attributes.fullname)
                    .join(", ");
                  return (
                    <div className="col-lg-4 col-md-6 col-sm-6 col-12" key={i}>
                      <Link href={getArticleUrl(ele)}>
                        <div className="blog-card-div">
                          <div className="blog-card ">
                            <div className=" blog-aspectratio-43">
                              <div className=" blog-aspectratio-image">
                                <div className="blog-img">
                                  {/* <Image src={"/images/demo.png"} /> */}
                                  <Image
                                    height={670}
                                    width={1448}
                                    quality={75}
                                    sizes="(max-width: 768px) 75vw, (max-width: 1200px) 40vw, 25vw"
                                    src={
                                      ele.attributes?.image
                                        ? toWebp(
                                            `${baseUrl}${ele.attributes?.image?.data?.attributes.url}`
                                          )
                                        : "/images/demo.png"
                                    }
                                    alt={`${ele.attributes?.image?.data?.attributes.alt}`}
                                  />
                                </div>
                              </div>
                              <div className=" blog-aspectratio-content">
                                <div className="blog-content ">
                                  <div>
                                    <h3>
                                      {decodeHTMLEntities(ele.attributes.title)}
                                    </h3>
                                    <h5>
                                      <span>By</span>
                                      {authorName}
                                    </h5>
                                  </div>
                                  <ul>
                                    <li>
                                      <span>{ele.attributes.time_to_read}</span>
                                    </li>
                                    {ele.attributes.publish_at ? (
                                      <li>
                                        <span>
                                          {/* <Moment format="MMM Do , YYYY">
                                            {ele.attributes.publish_at}
                                          </Moment> */}
                                          {dayjs(
                                            ele.attributes.publish_at
                                          ).format("MMM Do, YYYY")}
                                        </span>
                                      </li>
                                    ) : null}
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>
                  );
                })
              ) : (
                <div
                  className="col-12 col-12 text-center d-flex align-items-center justify-content-center"
                  style={{ minHeight: (pageSize / 2) * 260 + "px" }}
                >
                  <h4 style={{ margin: "70px auto", textAlign: "center" }}>
                    No Blogs Found
                  </h4>
                </div>
              )}
            </div>
            <div className="row">
              <div className="col-lg-12">
                <nav className="m-0">
                  <ReactPaginate
                    className="pagination"
                    breakLabel="..."
                    previousLabel={
                      <Image src={"/images/right-p.svg"} alt="Previous" />
                    }
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={5}
                    pageCount={
                      pagination?.pageCount ? pagination?.pageCount : 0
                    }
                    nextLabel={<Image src={"/images/left-p.svg"} alt="Next" />}
                    renderOnZeroPageCount={null}
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    nextLinkClassName="page-link"
                    previousLinkClassName="page-link"
                  />
                </nav>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CategoryStories;
